import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import coinIcon from '../../../assets/images/coin-icon.png';
import AudioPlayer from '../../../Components/AudioPlayer/AudioPlayer';
import { usePageTitle } from '../../../Hooks/usePageTitle';

import InnerBanner from '../../../Components/InnerBanner/InnerBanner';
import ProductSlider from '../../../Components/ProductSlider/ProductSlider';
import { getUserProfile } from '../../../Services/User/Matching';

const UserProfile = () => {
  usePageTitle('My Profile');

  const navigate = useNavigate();
  const { id } = useParams();
  console.log(id, 'id')
  const { data: user, isLoading } = useQuery({
    queryKey: ['profile'],
    queryFn: () => getUserProfile(id),
  });

  return (
    <>
      <InnerBanner heading="My Profile" />
      <section className="py-sm-5 py-4">
        <Container>
          <div className="profile-header text-center">
            <div className="profile-avatar-wrapper">
              <img src={user?.image} alt="Profile" className="profile-avatar" />
            </div>
            {user?.boost && (
              <div className="text-center">
                <p className="mb-0 blue-text">Profile is on Boost</p>
              </div>
            )}
          </div>
          <Row>
            <Col xs={12} xxl={8} lg={7} className="my-3">
              <div className="profile-details">

                <div className="detail-row">
                  <div className="detail-item">
                    <label className=''>About:</label>
                    <p>{user?.about}</p>
                  </div>
                </div>
                <div className="detail-row">
                  {(user?.profile?.outdoor_and_sports_hobbies ||
                    user?.profile?.artistic_and_creative_hobbies ||
                    user?.profile?.intellectual_and_educational_hobbies ||
                    user?.profile?.culinary_and_lifestyle_hobbies ||
                    user?.profile?.fitness_and_wellness_hobbies ||
                    user?.profile?.adventure_and_exploration_hobbies ||
                    user?.profile?.technology_and_gaming_hobbies ||
                    user?.profile?.social_and_community_hobbies) ? (
                    <div className="detail-item">
                      <label className=''>Explore your hobbies and interests</label>
                      <p>{user?.profile?.outdoor_and_sports_hobbies?.join(', ')} {user?.profile?.artistic_and_creative_hobbies?.join(', ')} {user?.profile?.intellectual_and_educational_hobbies?.join(', ')} {user?.profile?.culinary_and_lifestyle_hobbies?.join(', ')} {user?.profile?.fitness_and_wellness_hobbies?.join(', ')} {user?.profile?.adventure_and_exploration_hobbies?.join(', ')} {user?.profile?.technology_and_gaming_hobbies?.join(', ')} {user?.profile?.social_and_community_hobbies?.join(', ')}</p>
                    </div>
                  ) : null}
                  <div className="detail-item">
                    <label className=''>What are you looking for?</label>
                    <p>{user?.about_match}</p>
                  </div>
                </div>

                <h4>Lets talk about lifestyle habits</h4>

                <div className="detail-row">
                  <div className="detail-item">
                    <label className=''>Do you drink?</label>
                    <p>{user?.profile?.do_you_drink}</p>
                  </div>
                  <div className="detail-item">
                    <label className=''>Do you smoke cigarettes?</label>
                    <p>{user?.profile?.do_you_smoke_cigarettes}</p>
                  </div>
                </div>

                <div className="detail-row">
                  <div className="detail-item">
                    <label className=''>Do you smoke weed?</label>
                    <p>{user?.profile?.do_you_smoke_week}</p>
                  </div>
                  <div className="detail-item">
                    <label className=''>Do you exercise?</label>
                    <p>{user?.profile?.do_you_excercise}</p>
                  </div>
                </div>

                <div className="detail-row">
                  <div className="detail-item">
                    <label className=''>Do you have any pets?</label>
                    <p>{user?.profile?.do_you_have_any_pets}</p>
                  </div>
                  <div className="detail-item">
                    <label className=''>What makes you, you?</label>
                    <p>{user?.profile?.what_makes_you_you}</p>
                  </div>
                </div>

                <div className="detail-row">
                  <div className="detail-item">
                    <label className=''>What's your communication style?</label>
                    <p>{user?.profile?.communication_style}</p>
                  </div>
                  <div className="detail-item">
                    <label className=''>What's your highest education level?</label>
                    <p>{user?.profile?.education_level}</p>
                  </div>
                </div>

                <div className="detail-row">
                  <div className="detail-item">
                    <label className=''>What languages do you speak?</label>
                    <p>{user?.profile?.languages_spoken?.join(', ')}</p>
                  </div>
                  <div className="detail-item">
                    <label className=''>Who do you want to plan a date with?</label>
                    <p>{user?.profile?.who_do_you_want_to_plan_a_date_with}</p>
                  </div>
                </div>

                <div className="detail-row">
                  <div className="detail-item">
                    <label className=''>What's your zodiac sign?</label>
                    <p>{user?.profile?.zodiac_sign}</p>
                  </div>
                  <div className="detail-item">
                    <label className=''>Do you have children?</label>
                    <p>{user?.profile?.has_children}</p>
                  </div>
                </div>

                <div className="detail-row">
                  <div className="detail-item">
                    <label className=''>What's your religion?</label>
                    <p>{user?.profile?.religion}</p>
                  </div>
                  <div className="detail-item">
                    <label className=''>What are your political views?</label>
                    <p>{user?.profile?.political_views}</p>
                  </div>
                </div>

                <div className="detail-row">
                  <div className="detail-item">
                    <label className=''>What's your occupation?</label>
                    <p>{user?.profile?.occupation}</p>
                  </div>
                  <div className="detail-item">
                    <label className=''>Who I am looking to plan a date with?</label>
                    <p className='text-capitalize'>{user?.preferences?.gender}</p>
                  </div>
                </div>

                <div className="detail-row">
                  <div className="detail-item">
                    <label className=''>What's your ethnicity?</label>
                    <p>{user?.profile?.ethnicity}</p>
                  </div>
                  <div className="detail-item">
                    <label className=''>What languages do you prefer?</label>
                    <p className='text-capitalize'>{user?.preferences?.languages?.join(', ')}</p>
                  </div>
                </div>

                <div className="detail-row">
                  <div className="detail-item">
                    <label className=''>What's your relationship status?</label>
                    <p>{user?.profile?.relationship_status}</p>
                  </div>
                  <div className="detail-item">
                    <label className=''>What's your body type?</label>
                    <p className='text-capitalize'>{user?.profile?.body_type}</p>
                  </div>
                </div>

                <div className="detail-row">
                  <div className="detail-item">
                    <label className=''>What's your height?</label>
                    <p>{user?.profile?.height}</p>
                  </div>
                </div>
              </div>
            </Col>
            <Col xs={12} xxl={4} lg={5} className="my-3">
              {user?.images?.length > 0 && (
                <>
                  <p className="mb-2">Images</p>
                  <ProductSlider images={user?.images} />
                </>
              )}
              {user?.videos?.length > 0 && (
                <>
                  <p className="mb-2">Videos</p>
                  <ProductSlider videos={user?.videos} />
                </>
              )}
              {user?.audio && (
                <div className="voice-intro-section">
                  <p className="mb-2">Audio</p>
                  <AudioPlayer audioUrl={user?.audio} />
                </div>
              )}
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default UserProfile;
